import {css} from 'lit';
export const styles = css`:host {
  min-height: var(--loader-min-height);
  display: block;
}

.loader {
  margin: 0 auto;
  position: relative;
  animation: 2s linear 0s infinite normal none running rotate;
  width: 56px;
  height: 56px;
}

.loader[cloak] {
  display: none;
}

@keyframes rotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
}

.dot {
  width: 50%;
  height: 50%;
  position: absolute;
  background-color: rgb(0, 25, 165);
  border-radius: 100%;
  animation: 2s ease-in-out 0s infinite normal none running bounce;
}

.dot.dot-1 {
  top: 0;
  left: 0;
}

.dot.dot-2 {
  bottom: 0;
  right: 0;
  animation-delay: -1s;
}
`;
export default styles;
